module.exports = __webpack_public_path__ + "nc_static/media/down-circle.svg.819d985f.icon";